import {
  DownloadO,
  IconClose,
  LogoWarppipe,
  SocialFacebook,
  SocialLinkedin,
  SocialTelegram,
} from '@/assets';
import DownloadPortfolioModal from '@/components/common/Modal';
import {
  LinkBookCall,
  LinkSocialFacebook,
  LinkSocialLinkedin,
  LinkSocialTelegram,
} from '@/constants/common';
import { ERoutePath } from '@/constants/route';
import { ArrowDown2, CallCalling, HambergerMenu } from 'iconsax-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Header = () => {
  const { t, i18n } = useTranslation();
  const lgnDefault = window.localStorage.getItem('language') || 'en';
  const language = ['jp', 'en', 'kr', 'vie'];
  const handleChangeLanguage = (lgn: string) => {
    window.localStorage.setItem('language', lgn);
    i18n.changeLanguage(lgn);
  };
  const [isOpen, setIsOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(false);

  const handleCloseMenu = () => {
    setActiveMenu(false);
  };

  return (
    <header className={`header-warppipe ${activeMenu ? 'active' : ''}`}>
      <Link to="/">
        <LogoWarppipe />
      </Link>
      <div className="header-warppipe__right">
        <div className="language">
          <span>{lgnDefault}</span>
          <ArrowDown2 className="arrow-icon" size="24" color="#101828" />
          <div className="language-dropdown">
            <div className="dropdown-line"></div>
            <ul>
              {language
                .filter((item) => item !== lgnDefault)
                .map((item) => (
                  <li key={item} onClick={() => handleChangeLanguage(item)}>
                    {item}
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div className="btn-box" onClick={() => window.open(LinkBookCall, '_blank')}>
          <span>{t('BOOK A CALL')}</span>
          <CallCalling size="24" color="#101828" />
        </div>
        <div className="btn-box" onClick={() => setActiveMenu(!activeMenu)}>
          <span>{activeMenu ? t('Close') : t('Menu')}</span>
          {activeMenu ? <IconClose /> : <HambergerMenu size="24" color="#101828" />}
        </div>
      </div>
      <div className={`menu-header ${activeMenu ? 'active' : ''}`}>
        <div className="menu-header__left">
          <p className="title">{t('Globally Accessible')}</p>
          <div className="info-company">
            <div className="address-company">
              <p className="text-company">{t('Vietnam Head Office')}</p>
              <div className="desc-company">
                <p>{t('Sky Tower, 17 Nguyen Chi Thanh Street, Ngoc Khanh, Ba Dinh, Hanoi')}</p>
                <p>{t('Tel: (+84)-816-644-466')}</p>
              </div>
            </div>
            <div className="address-company">
              <p className="text-company">{t('Korea Office')}</p>
              <div className="desc-company">
                <p>
                  {t(
                    '191, Dongbaekjungang-ro, Giheung-gu, Yongin-si, Gyeonggi-do, 8th floor, #8489 (Jung-dong, City Plaza)'
                  )}
                </p>
                <p>{t('Tel: (+82) 1688-7044')}</p>
              </div>
            </div>
          </div>
          <div className="social-media">
            <a href={LinkSocialLinkedin} target="_blank" rel="noopener noreferrer">
              <SocialLinkedin />
            </a>
            <a href={LinkSocialFacebook} target="_blank" rel="noopener noreferrer">
              <SocialFacebook />
            </a>
            <a href={LinkSocialTelegram} target="_blank" rel="noopener noreferrer">
              <SocialTelegram />
            </a>
          </div>
        </div>
        <div className="menu-header__right">
          <div className="item-menu">
            <Link className="link-menu" to={ERoutePath.HOME} onClick={handleCloseMenu}>
              {t('Home')}
            </Link>
          </div>
          <div className="item-menu">
            <Link
              className="link-menu"
              to={ERoutePath.SOFTWARE_DEVELOPMENT_SERVICE}
              onClick={handleCloseMenu}
            >
              {t('Software Development Service')}
            </Link>
            <div className="list-software-development">
              <Link to={ERoutePath.SOFTWARE_DEVELOPMENT_SERVICE} onClick={handleCloseMenu}>
                {t('Software Development Service')}
              </Link>
              <Link to={ERoutePath.INNOVATIVE_TECHNOLOGY_SOLUTION} onClick={handleCloseMenu}>
                {t('Innovative Technology Solutions')}
              </Link>
              <Link
                to={ERoutePath.ENTERPRISE_SOLUTIONS_CLOUD_IT_SERVICES}
                onClick={handleCloseMenu}
              >
                {t('Enterprise Solutions, Cloud & IT Services')}
              </Link>
              <Link to={ERoutePath.TRADING_SYSTEM_SOLUTIONS} onClick={handleCloseMenu}>
                {t('Trading System Solutions')}
              </Link>
            </div>
          </div>
          <div className="item-menu">
            <Link
              className="link-menu"
              to={ERoutePath.CLIENT_APPLICATION_AREAS}
              onClick={handleCloseMenu}
            >
              {t('Client & Application')}
            </Link>
          </div>
          <div className="item-menu">
            <Link className="link-menu" to={ERoutePath.CORE_SERVICES} onClick={handleCloseMenu}>
              {t('Core Services')}
            </Link>
          </div>
          <div className="item-menu">
            <Link className="link-menu" to="#">
              {t('Portfolio')}
            </Link>
            <div className="btn-box" onClick={() => setIsOpen(true)}>
              <span>{t('Download portfolio')}</span>
              <DownloadO />
            </div>
          </div>
          <div className="item-menu">
            <Link
              className="link-menu"
              to={ERoutePath.COMPANY_INFORMATION}
              onClick={handleCloseMenu}
            >
              {t('Company Information')}
            </Link>
          </div>
        </div>
      </div>
      <DownloadPortfolioModal isOpen={isOpen} handleClose={() => setIsOpen(false)} />
    </header>
  );
};

export default Header;
